<template>
  <div>
    <el-dialog title="Password Reset" :visible.sync="dialogVisible" width="30%">
      <span>Are you sure you want to continue?</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">Cancel</el-button>
        <el-button type="warning" @click="confirmReset">Confirm</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "PasswordRestDialog",
  props: {
    open: Boolean,
    callback: Function,
  },
  data() {
    return {
      dialogVisible: false,
    };
  },
  watch: {
    open: function (newVal) {
      this.dialogVisible = newVal;
    },
  },
  methods: {
    openDialog() {
      this.dialogVisible = true;
    },

    confirmReset() {
      this.dialogVisible = false;
      if (this.callback) {
        this.callback(true);
      }
    },
    cancel() {
      this.dialogVisible = false;
      if (this.callback) {
        this.callback(false);
      }
    },
  },
};
</script>
